import axios from 'axios'
import _get from 'lodash/get'

import { ERROR_MESSAGE_DELETING, ERROR_MESSAGE_SAVING } from '../constants'
import { quarterlyTaxReturnsAnnualSummarySelector } from '../selectors'
import { getCurrentYearQuarterlyTaxReturnsAnnualSummary } from '../selectors/quarterly-tax-returns-annual-summary'
import { syncProfile } from '../store/profile'
import { track, TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_START } from '../trackers'
import { handleRequestError } from './request'

export const ACTIVATE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY = 'ACTIVATE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY'
export const ASSIGN_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_ACCOUNTANT =
    'ASSIGN_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_ACCOUNTANT'
export const CREATE_AND_ACTIVATE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY =
    'CREATE_AND_ACTIVATE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY'
export const CREATE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY = 'CREATE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY'
export const DELETE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY = 'DELETE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY'
export const RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY = 'RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY'
export const REQUEST_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY = 'REQUEST_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY'
export const SAVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY = 'SAVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY'
export const SAVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_STATUS = 'SAVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_STATUS'
export const UPDATE_AND_SAVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY =
    'UPDATE_AND_SAVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY'
export const UPDATE_AND_SAVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_STATUS =
    'UPDATE_AND_SAVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_STATUS'
export const UPDATE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_STATUS = 'UPDATE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_STATUS'
export const REQUEST_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_PAYMENTS =
    'REQUEST_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_PAYMENTS'
export const RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_PAYMENTS =
    'RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_PAYMENTS'
export const REQUEST_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_PAYMENT_INVOICE =
    'REQUEST_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_PAYMENT_INVOICE'
export const RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_PAYMENT_INVOICE =
    'RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_PAYMENT_INVOICE'
export const INVALIDATE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY = 'INVALIDATE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY'

export const createQuarterlyTaxReturnsAnnualSummaryAndActivate = (data) => (dispatch) => {
    dispatch({ type: CREATE_AND_ACTIVATE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY, data })

    const { taxYear } = data

    return dispatch(createQuarterlyTaxReturnsAnnualSummary({ taxYear })).then(() => {
        track(TRACK_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_START, { taxYear })
    })
}

export const createQuarterlyTaxReturnsAnnualSummary = (data) => (dispatch, getState) => {
    const { quarterlyTaxReturnsAnnualSummary, profile } = getState()

    const { isCreating } = quarterlyTaxReturnsAnnualSummary

    if (isCreating) return Promise.reject()

    dispatch({ type: CREATE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY, data })

    const { id: userId } = profile

    const { taxYear } = data

    return axios
        .post('/quarterlytaxreturnsannualsummaries', { userId, taxYear })
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(
                receiveQuarterlyTaxReturnsAnnualSummary({
                    ...responseData,
                    shouldFetch: false,
                    isCreating: false,
                    fetchSuccessful: true,
                })
            )
            return responseData
        })
        .catch((error) => {
            dispatch(
                handleRequestError(error, {
                    customMessage: `Ha habido un problema al crear tu resumen anual de ${taxYear}`,
                })
            )
            return Promise.reject(error)
        })
}

export const requestQuarterlyTaxReturnsAnnualSummary = (id) => (dispatch, getState) => {
    dispatch({ type: REQUEST_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY, data: { id } })

    const state = getState()
    const { id: activeQuarterlyTaxReturnsAnnualSummaryId } = quarterlyTaxReturnsAnnualSummarySelector(state) || {}
    const { id: currentYearQuarterlyTaxReturnsAnnualSummaryId } =
        getCurrentYearQuarterlyTaxReturnsAnnualSummary(state) || {}

    const quarterlyTaxReturnsAnnualSummaryIdToRequest =
        id || activeQuarterlyTaxReturnsAnnualSummaryId || currentYearQuarterlyTaxReturnsAnnualSummaryId

    return axios
        .get(`/quarterlytaxreturnsannualsummaries/${quarterlyTaxReturnsAnnualSummaryIdToRequest}`)
        .then((response) => {
            const responseData = response?.data || {}

            dispatch(receiveQuarterlyTaxReturnsAnnualSummary({ ...responseData, fetchSuccessful: true }))

            return responseData
        })
        .catch((error) => {
            dispatch(receiveQuarterlyTaxReturnsAnnualSummary({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))

            return Promise.reject(error)
        })
}

export const receiveQuarterlyTaxReturnsAnnualSummary = (data) => (dispatch) => {
    dispatch(syncProfile({ key: 'quarterlyTaxReturnsAnnualSummaries', update: data }))

    dispatch({
        type: RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY,
        data,
    })
}

export const requestQuarterlyTaxReturnsAnnualSummaryPayments = (quarterlyTaxReturnsAnnualSummaryId) => (dispatch) => {
    dispatch({ type: REQUEST_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_PAYMENTS })

    return axios
        .get(`/quarterlytaxreturnsannualsummaries/${quarterlyTaxReturnsAnnualSummaryId}/payments`)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveQuarterlyTaxReturnsAnnualSummaryPayments({ payments: responseData }))
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}
export const receiveQuarterlyTaxReturnsAnnualSummaryPayments = (data) => ({
    type: RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_PAYMENTS,
    data,
})

export const requestQuarterlyTaxReturnsAnnualSummaryPaymentInvoice = (data) => (dispatch) => {
    dispatch({ type: REQUEST_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_PAYMENT_INVOICE, data })

    const { paymentId } = data

    return axios
        .get(`payments/${paymentId}/downloadinvoice`)
        .then((response) => {
            const responseData = _get(response, ['data'], '')
            dispatch(
                receiveQuarterlyTaxReturnsAnnualSummaryPaymentInvoice({ invoiceDownloadUrl: responseData, paymentId })
            )
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error))
            return Promise.reject(error)
        })
}

const receiveQuarterlyTaxReturnsAnnualSummaryPaymentInvoice = (data) => ({
    type: RECEIVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_PAYMENT_INVOICE,
    data,
})

export const updateAndSaveQuarterlyTaxReturnsAnnualSummary = (data) => (dispatch) => {
    dispatch({ type: UPDATE_AND_SAVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY, data })

    dispatch(receiveQuarterlyTaxReturnsAnnualSummary(data))

    return dispatch(saveQuarterlyTaxReturnsAnnualSummary())
}

export const saveQuarterlyTaxReturnsAnnualSummary = () => (dispatch, getState) => {
    dispatch({ type: SAVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY })

    const { quarterlyTaxReturnsAnnualSummary } = getState()

    const { id: quarterlyTaxReturnsAnnualSummaryId } = quarterlyTaxReturnsAnnualSummary

    return axios
        .put(
            `/quarterlytaxreturnsannualsummaries/${quarterlyTaxReturnsAnnualSummaryId}`,
            quarterlyTaxReturnsAnnualSummary
        )
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveQuarterlyTaxReturnsAnnualSummary(responseData))
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const saveQuarterlyTaxReturnsAnnualSummaryStatus = (data) => (dispatch) => {
    dispatch({ type: SAVE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_STATUS, data })

    const { quarterlyTaxReturnsAnnualSummaryId, status } = data

    return axios
        .put(`/quarterlytaxreturnsannualsummaries/${quarterlyTaxReturnsAnnualSummaryId}/status/${status}`)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveQuarterlyTaxReturnsAnnualSummary(responseData))
            return responseData
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const deleteQuarterlyTaxReturnsAnnualSummary = (id) => (dispatch) => {
    dispatch({ type: DELETE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY, data: { id } })

    return axios.delete(`/quarterlytaxreturnsannualsummaries/${id}`).catch((error) => {
        dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DELETING }))
        return Promise.reject(error)
    })
}

export const invalidateQuarterlyTaxReturnsAnnualSummary = () => ({
    type: INVALIDATE_QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY,
})
